import { getStore } from '../store/storeInstance';

/**
 * AuthService
 *
 * A service class to support user authentication.
 */

class AuthServiceCls {
  /**
   * Get the auth state.
   */
  getAuthState() {
    const currentState = getStore().getState();
    return currentState.authentication;
  }

  /**
   * Is the current user an super admin. We lean on
   * the flag set in the JWT.
   */
  isSuperAdmin() {
    const currentState = getStore().getState();

    // sometimes as super admins we "login as" another user, and so
    // the JWT info isn't added to user state
    return currentState.authentication.hasOwnProperty('isSuperAdmin')
      ? currentState.authentication.isSuperAdmin
      : currentState.authentication.user.role === 'admin';
  }

  /**
   * Is the current user an organisation admin.
   * We lean on the "role" field of the user state.
   */
  isOrgAdmin() {
    const currentState = getStore().getState();
    return (
      currentState.authentication.user?.role === 'organisationAdmin' ?? false
    );
  }

  /**
   * Is the current user's organisation a Beta Tester?
   * We lean on the "organisation.isBetaTester" field of the user state.
   */
  isBetaTesterOrg() {
    const currentState = getStore().getState();
    return (
      currentState.authentication.user?.organisation?.isBetaTester ?? false
    );
  }
}

// service class is a singleton
const AuthService = new AuthServiceCls();

export { AuthService };
